/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Table, theme } from "@nordcloud/gnui";
import { ResourcesSummary } from "~/views/plans/PlanCreate/components/PlanCreateWizard/PlanSummary/ResourcesSummary";
import { SelectedPlanEntity } from "../types";
import { ResourceGroupSummary } from "./ResourceGroupsSummary";

export function PlanActionSummary({ action }: { action: SelectedPlanEntity }) {
  return (
    <>
      <Table.td>
        <ActionRow>{action.name}</ActionRow>
      </Table.td>
      <Table.td
        css={{
          padding: `${theme.spacing.spacing02}`,
        }}
      >
        <ResourceGroupSummary action={action} />
      </Table.td>
      <Table.td
        css={{
          padding: `${theme.spacing.spacing02}`,
        }}
      >
        <ResourcesSummary action={action} />
      </Table.td>
    </>
  );
}

const ActionRow = styled.div`
  align-items: left;
  word-break: break-word;
`;
